// Datenschutz.jsx
import React from 'react'
import { Helmet } from 'react-helmet-async'

function Datenschutz() {
  return (
    <>
      <Helmet>
        <title>Datenschutz | Payroll Expert</title>
        <meta name="description" content="Datenschutzerklärung (DSGVO) von Payroll Expert. Informationen zum Umgang mit Ihren Daten." />
      </Helmet>
      <div className="min-h-screen bg-gray-50 py-20 px-2 sm:px-4 md:px-6">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-12 border border-gray-200">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-black text-gray-900 mb-8 sm:mb-10 md:mb-12 text-center border-b-4 border-green-600 pb-4 sm:pb-6 md:pb-8 break-words">
          Datenschutzerklärung (DSGVO)
        </h1>

        <div className="space-y-8 text-lg leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-green-900 mb-4">1. Verantwortliche Stelle</h2>
            <div className="p-6 bg-emerald-50 border-l-4 border-emerald-400 rounded-xl">
              <p>Natalia Hill<br />Maximilianstraße 4<br />80539 München<br />Bayern, Deutschland</p>
              <p>E-Mail: <a href="mailto:support@payroll-experten.de" className="text-green-600 hover:underline">support@payroll-experten.de</a></p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-green-900 mb-4">2. Erhebung und Speicherung personenbezogener Daten</h2>
            <p className="p-6 bg-gray-50 rounded-xl mb-6">
              Personenbezogene Daten werden nur erhoben, wenn Sie diese freiwillig mitteilen, z. B. per E-Mail, Kontaktformular oder WhatsApp.
            </p>
            <ul className="list-disc pl-8 mb-6">
              <li>Name</li>
              <li>E-Mail-Adresse</li>
              <li>Telefonnummer</li>
              <li>übermittelte Inhalte und Dokumente</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-green-900 mb-4">3. Zweck der Datenverarbeitung</h2>
            <ul className="list-disc pl-8 mb-6">
              <li>Beantwortung von Anfragen</li>
              <li>Vorbereitung einer möglichen Zusammenarbeit</li>
              <li>Durchführung vorvertraglicher Maßnahmen</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-green-900 mb-4">4. Weitergabe von Daten</h2>
            <p className="p-6 bg-gray-50 rounded-xl mb-6">
              Eine Weitergabe Ihrer Daten an Dritte erfolgt nicht, es sei denn, sie ist gesetzlich vorgeschrieben oder zur Vertragsdurchführung erforderlich.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-green-900 mb-4">5. Speicherdauer</h2>
            <p className="p-6 bg-yellow-50 rounded-xl mb-6">
              Ihre Daten werden nur so lange gespeichert, wie es für den jeweiligen Zweck erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-green-900 mb-4">6. Ihre Rechte</h2>
            <ul className="list-disc pl-8 mb-6">
              <li>Auskunft</li>
              <li>Berichtigung oder Löschung</li>
              <li>Einschränkung der Verarbeitung</li>
              <li>Widerspruch</li>
            </ul>
            <p className="p-6 bg-gray-50 rounded-xl">
              Kontakt: <a href="mailto:anfragen@payroll-experten.de" className="text-green-600 hover:underline">anfragen@payroll-experten.de</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-green-900 mb-4">7. Datensicherheit</h2>
            <p className="p-6 bg-gray-50 rounded-xl mb-6">
              Diese Website nutzt angemessene technische und organisatorische Maßnahmen zum Schutz Ihrer Daten.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-green-900 mb-4">8. Kontakt per E-Mail & WhatsApp</h2>
            <p className="p-6 bg-gray-50 rounded-xl mb-6">
              Die Kontaktaufnahme erfolgt freiwillig. Die übermittelten Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage verwendet.
            </p>
          </section>
        </div>
      </div>
      </div>
    </>
  )
}

export default Datenschutz
